import React, { useRef, useEffect } from 'react';
import styles from './componentCss/ImageBanner.module.css';
import { MouseIcon } from 'lucide-react';
import { t } from 'i18next';

const ImageBanner = ({
  imageSrc,
  text,
  height,
}) => {
  const bannerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const opacity = Math.max(1 - scrollY / 600, 0);
      const translateY = scrollY * 0.3;

      if (bannerRef.current) {
        bannerRef.current.style.opacity = opacity.toString();
        bannerRef.current.style.transform = `translateY(${translateY}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.banner} style={{ height }} ref={bannerRef}>
      {/* Image de fond */}
      <div className={styles.imageWrapper}>
        <img 
          src={imageSrc} 
          alt={"banner"}
          className={styles.backgroundImage}
        />
      </div>

      <div className={styles.imageOverlay}></div>

      {/* Texte central */}
      <div className={styles.textContainer}>
        <h1 className={styles.mainSlogan}>{text}</h1>
      </div>


      {/* Icône de scroll */}
      <div className={styles.scrollMouse}>
        <MouseIcon className={styles.mouseFrame} />
        <div className={styles.scrollDot}></div>
      </div>
    </div>
  );
};

export default ImageBanner;
